import { api } from '../utils/api';

type Params = {
  arrival: string;
  departure: string;
  withPromocode?: boolean;
  reservationId?: number;
  rateFlow?: string; // TODO
};

export type Availability = {
  date: string;
  price: number;
  availability: {
    color: string; // hex
    font_color: string; // hex
    legend: string;
  };
};

export async function getAvailability(hotelId: number, params: Params) {
  const { arrival, departure, withPromocode, rateFlow, reservationId } = params;
  const searchParams = new URLSearchParams({
    arrival,
    departure,
  });
  withPromocode && searchParams.append('is_promocode', '1');
  rateFlow && searchParams.append('rate_flow', rateFlow);
  reservationId && searchParams.append('reservation_id', `${reservationId}`);

  const url = `/api/v1/color-availability/${hotelId}/?${searchParams.toString()}`

  const response = await api.get<Availability[]>(url);
  return response;
}
